import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var LeafSVG = function LeafSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.71 2.29a1 1 0 00-.89-.29c-.66.12-16.22 3-20.71 7.45A13.61 13.61 0 004 17.3a9.19 9.19 0 002.11 7.16l-3.82 3.83a1 1 0 000 1.42 1 1 0 001.42 0l3.82-3.83a9.15 9.15 0 006 2.18A9.93 9.93 0 0014.7 28a13.61 13.61 0 007.83-4.1C27 19.4 29.87 3.84 30 3.18a1 1 0 00-.29-.89zm-9 10.42l-11 11a1 1 0 01-1.42 0 1 1 0 010-1.42l11-11a1 1 0 011.42 1.42z"
  }));
};
LeafSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
LeafSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Leaf")
};
export default withIcon(LeafSVG);